import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'barcode-selection-dialog',
  template: `
    <h2 mat-dialog-title>Produtos com mesmo código de barras</h2>
    <mat-dialog-content>
      <p style="margin-bottom: 12px; color: #666;">Selecione o produto desejado:</p>
      <mat-selection-list [multiple]="false" (selectionChange)="onSelect($event)">
        <mat-list-option *ngFor="let p of data.produtos" [value]="p">
          {{ formatProduto(p) }}
        </mat-list-option>
      </mat-selection-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancelar</button>
    </mat-dialog-actions>
  `,
})
export class BarcodeSelectionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BarcodeSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { produtos: any[] }
  ) {}

  formatProduto(p: any): string {
    const cod = String(p?.codigo ?? '').padStart(6, '0');
    const barras = String(p?.codigobarra1 ?? '').trim();
    const desc = String(p?.descricao ?? '').trim();
    const ref = String(p?.referencia ?? '').trim();
    let label = `${cod} | ${barras} | ${desc}`;
    if (ref) {
      label += ` | Ref: ${ref}`;
    }
    return label;
  }

  onSelect(event: any) {
    const selected = event?.options?.[0]?.value;
    if (selected) {
      this.dialogRef.close(selected);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
